export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "App";

export const APP_LOGO =
  import.meta.env.VITE_APP_LOGO ||
  "https://placehold.co/128x128/E1E7EF/1F2937?text=App";

export const OAUTH_PORTAL_URL = import.meta.env.VITE_OAUTH_PORTAL_URL || "";
export const APP_ID = import.meta.env.VITE_APP_ID || "";

/**
 * Get OAuth login URL
 */
export function getOAuthLoginUrl(): string {
  if (!OAUTH_PORTAL_URL || !APP_ID) {
    console.error(
      "OAuth not configured: missing VITE_OAUTH_PORTAL_URL or VITE_APP_ID"
    );
    return "";
  }
  const callbackUrl = `${window.location.origin}/api/oauth/callback`;
  return `${OAUTH_PORTAL_URL}/oauth/authorize?appId=${APP_ID}&redirectUri=${encodeURIComponent(callbackUrl)}`;
}

// ===== Route Constants =====
// BUG-L3: Centralize route paths to prevent hardcoding across multiple files

/** ໜ້າແກ້ໄຂຂໍ້ມູນລູກຄ້າ (7-tab mobile form) */
export const ROUTE_EDIT_CUSTOMER = (customerId: number | string) =>
  `/edit-customer-mobile/${customerId}`;

/** ໜ້າລາຍລະອຽດຄຳຂໍສິນເຊື່ອ */
export const ROUTE_LOAN_DETAIL = (loanId: number | string) =>
  `/loan-application/${loanId}`;

/** ໜ້າລາຍການຄຳຂໍສິນເຊື່ອ */
export const ROUTE_LOAN_LIST = "/loan-applications";

/** ໜ້າຄຳຂໍຂອງຂ້ອຍ */
export const ROUTE_MY_APPLICATIONS = "/my-applications";
